import { useDevice, useViewport } from '@treatwell/ui';
import React from 'react';
import { ChannelLoyalty } from 'js/model/rainbow/content/ChannelOutput';
import { substituteWithDictionary } from 'js/helpers/i18n';
import { CMSTreatwellRewardsPage } from 'js/model/cms/cms-treatwell-rewards';
import { BannerCTA } from '../BannerCTA';
import styles from './Hero.module.css';
import phoneDeCH from './assets/de_CH-header.webp';
import phoneDe from './assets/de-header.webp';
import phoneElGR from './assets/el_GR-header.webp';
import phoneEnGB from './assets/en_GB-header.webp';
import phoneEnIE from './assets/en_IE-header.webp';
import phoneEsES from './assets/es_ES-header.webp';
import phoneFrFR from './assets/fr_FR-header.webp';
import phoneItIT from './assets/it_IT-header.webp';
import phoneLtLT from './assets/lt_LT-header.webp';
import phoneNlNL from './assets/nl-header.webp';
import phonePtPT from './assets/pt_PT-header.webp';
import phoneFrCh from './assets/fr_CH-header.webp';
import phoneItCh from './assets/it_CH-header.webp';
import { BannerCTAProps } from '../BannerCTA/BannerCTA';
import { getAchievements } from '../utils/getAchievements';

const localesMap: Record<string, string> = {
  /* eslint-disable @typescript-eslint/naming-convention */
  en_GB: phoneEnGB,
  en_IE: phoneEnIE,
  fr_FR: phoneFrFR,
  es_ES: phoneEsES,
  it_IT: phoneItIT,
  de_CH: phoneDeCH,
  de_AT: phoneDe,
  de_DE: phoneDe,
  lt_LT: phoneLtLT,
  en_BE: phoneEnIE,
  fr_BE: phoneFrFR,
  nl_BE: phoneNlNL,
  en_NL: phoneEnIE,
  nl_NL: phoneNlNL,
  pt_PT: phonePtPT,
  el_GR: phoneElGR,
  it_CH: phoneItCh,
  fr_CH: phoneFrCh,
};

type HeroSectionProps = BannerCTAProps & { img: string };

const HeroSection = ({
  title,
  description,
  cta,
  align,
  img,
}: HeroSectionProps) => {
  return (
    <section className={styles.root}>
      <div className={styles.container}>
        <div className={styles.phone}>
          <img src={img} alt="" className={styles.img} />
        </div>
        <div className={styles.banner}>
          <BannerCTA
            title={title}
            description={description}
            cta={{
              label: cta.label,
            }}
            align={align}
          />
        </div>
      </div>
    </section>
  );
};

type Props = {
  channel: ChannelLoyalty;
  cmsValues: CMSTreatwellRewardsPage;
};

export const HeroSectionContainer = ({ channel, cmsValues }: Props) => {
  const img = localesMap[channel.locale];
  const { isMobile } = useDevice();
  const isMobileViewport = useViewport({
    device: ['mobile', 'tablet'],
    serverRender: isMobile,
  });
  const achievements = channel.loyalty.achievements;
  const { lowestAchievementValue, highestAchievementValue } = getAchievements({
    achievements,
    channel,
  });
  const cms = cmsValues.page['treatwell-rewards'].hero;
  const title = substituteWithDictionary(cms.title, {
    lowestAchievementValue,
    highestAchievementValue,
  });
  return (
    <HeroSection
      title={title}
      description={cms.description}
      cta={{
        label: cms.cta.label,
      }}
      align={isMobileViewport ? 'center' : 'start'}
      img={img}
    />
  );
};
